module.exports = __webpack_public_path__ + "img/smaller-than.3edba79d.svg";